export type SafeAuthSessionUser = {
  id: string;
  email: string;
  name?: string;
  role?: string;
  [key: string]: unknown;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function presentFieldValue(value: unknown): unknown {
  return value instanceof Date ? value.toISOString() : value;
}

const SECRET_BEARING_FIELD_NAMES = new Set([
  "token",
  "sessionToken",
  "accessToken",
  "refreshToken",
  "idToken",
]);

export function presentSafeAuthSessionUser(
  user: unknown,
  additionalFieldNames: string[] = [],
): SafeAuthSessionUser | null {
  if (!isRecord(user) || typeof user.id !== "string" || typeof user.email !== "string") {
    return null;
  }

  const safeUser: SafeAuthSessionUser = {
    id: user.id,
    email: user.email,
  };

  if (typeof user.name === "string") safeUser.name = user.name;

  if (typeof user.role === "string") safeUser.role = user.role;

  for (const fieldName of additionalFieldNames) {
    if (SECRET_BEARING_FIELD_NAMES.has(fieldName)) continue;
    if (fieldName in user && user[fieldName] !== undefined) {
      safeUser[fieldName] = presentFieldValue(user[fieldName]);
    }
  }

  return safeUser;
}
